"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSliderStepLabel = exports.StyledSliderPoint = exports.StyledSliderThumb = exports.StyledSliderFillCircleThumb = exports.StyledSliderTooltipText = exports.StyledSliderTooltip = exports.StyledSliderTrack = exports.StyledSlider = exports.labelConfig = exports.tooltipConfig = exports.thumbConfig = exports.trackConfig = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const Text_1 = require("../../Text");
exports.trackConfig = {
    height: helpers_1.SPACING_XXS,
    areaClickHeight: helpers_1.SPACING_L
};
const pointConfig = {
    width: helpers_1.SPACING_L,
    internalCircleWidth: '6px'
};
exports.thumbConfig = {
    width: helpers_1.SPACING_L,
    padding: helpers_1.SPACING_XS
};
exports.tooltipConfig = {
    height: helpers_1.SPACING_XXL,
    marginBottom: helpers_1.SPACING_XS
};
exports.labelConfig = {
    marginTop: helpers_1.SPACING_M,
    height: helpers_1.FONT_LINE_HEIGHT_S
};
const getTooltipConfigHeight = ({ hasTooltip }) => {
    return hasTooltip ? exports.tooltipConfig.height : 0;
};
const getTooltipConfigMarginBottom = ({ hasTooltip }) => {
    return hasTooltip ? exports.tooltipConfig.marginBottom : 0;
};
exports.StyledSlider = styled_components_1.default.div `
    position: relative;
    user-select: none;

    ${({ hasStepLabels }) => {
    if (hasStepLabels) {
        return (0, styled_components_1.css) `
                height: calc(
                    ${getTooltipConfigHeight} + ${getTooltipConfigMarginBottom} +
                        ${exports.thumbConfig.padding} + (${exports.thumbConfig.width} + ${exports.trackConfig.height}) / 2 +
                        ${exports.labelConfig.marginTop} + ${exports.labelConfig.height}
                );
            `;
    }
    return (0, styled_components_1.css) `
            height: calc(
                ${exports.thumbConfig.width} + ${exports.thumbConfig.padding} + ${getTooltipConfigHeight} +
                    ${getTooltipConfigMarginBottom}
            );
        `;
}}
`;
exports.StyledSliderTrack = styled_components_1.default.div `
    width: calc(100% - ${exports.thumbConfig.width});
    height: ${exports.trackConfig.areaClickHeight};
    left: calc(${exports.thumbConfig.width} / 2);
    top: calc(
        ((${exports.thumbConfig.width} - ${exports.trackConfig.areaClickHeight}) / 2) + ${exports.thumbConfig.padding} +
            ${getTooltipConfigHeight} + ${getTooltipConfigMarginBottom}
    );
    position: absolute;
    overflow: visible;

    :before {
        position: absolute;
        content: '';
        height: ${exports.trackConfig.height};
        left: 0;
        top: calc((${exports.trackConfig.areaClickHeight} - ${exports.trackConfig.height}) / 2);
        width: 100%;
    }

    ${({ theme, disabled }) => (0, styled_components_1.css) `
        :before {
            background-color: ${disabled
    ? theme.colorControlBorderDisabled
    : theme.colorBorderMain};
        }
    `}
`;
exports.StyledSliderTooltip = styled_components_1.default.div `
    ${({ theme, position, disabled }) => (0, styled_components_1.css) `
        top: calc(
            (${exports.trackConfig.areaClickHeight} - ${exports.trackConfig.height}) / 2 -
                (${getTooltipConfigHeight} + ${theme.spacing.m})
        );
        left: calc(${100 - position >= position ? position : ''}% - ${position}px);
        right: calc(${100 - position < position ? 100 - position : ''}% - ${100 - position}px);
        outline: none;
        z-index: 1;
        position: absolute;
        background-color: ${theme.colors.backgrounds.none};
        width: calc(${theme.spacing.xxxl} + ${theme.spacing.xl} + ${theme.spacing.xxs});
        height: ${getTooltipConfigHeight};
        border: ${helpers_1.BASE_BORDER_WIDTH} solid
            ${disabled ? theme.colorControlBorderDisabled : theme.colorControlBorderAccent};
    `}
`;
exports.StyledSliderTooltipText = (0, styled_components_1.default)(Text_1.Text) ``;
exports.StyledSliderFillCircleThumb = styled_components_1.default.div `
    width: ${helpers_1.SPACING_M};
    height: ${helpers_1.SPACING_M};
    border-radius: 50%;
`;
exports.StyledSliderThumb = styled_components_1.default.div `
    box-sizing: border-box;
    width: ${exports.thumbConfig.width};
    height: ${exports.thumbConfig.width};
    border: 0;
    outline: none;
    z-index: 1;
    position: absolute;
    padding: ${exports.thumbConfig.padding};
    border-radius: 50%;

    ${({ position, disabled, theme }) => (0, styled_components_1.css) `
        top: calc((${exports.trackConfig.areaClickHeight} - ${exports.thumbConfig.width}) / 2);
        left: calc(${position}% - ${exports.thumbConfig.width} / 2);

        [data-track-fill-circle-thumb='true'] {
            background-color: ${disabled ? theme.colorControlIconDisabled : theme.colorControlIcon};
        }
    `}

    ${({ theme, disabled }) => !disabled &&
    (0, styled_components_1.css) `
            &:hover {
                &,
                & + [data-track-tooltip='true'] {
                    border-color: transparent;
                    background-color: ${theme.colorHighlightLight};
                }
            }

            &:active {
                &,
                & + [data-track-tooltip='true'] {
                    border-color: transparent;
                    background-color: ${theme.colorHighlightDark};
                }
            }
        `}
`;
exports.StyledSliderPoint = styled_components_1.default.div `
    ${({ theme, leftValue, disabled }) => (0, styled_components_1.css) `
        left: calc(${leftValue}% - ${pointConfig.width} / 2);
        top: calc((${exports.trackConfig.areaClickHeight} - ${pointConfig.width}) / 2);
        position: absolute;
        -webkit-appearance: none;
        border: 0;
        border-radius: 50%;
        height: ${pointConfig.width};
        width: ${pointConfig.width};

        &:after {
            content: '';
            position: absolute;
            left: calc((${pointConfig.width} - ${pointConfig.internalCircleWidth}) / 2);
            top: calc((${pointConfig.width} - ${pointConfig.internalCircleWidth}) / 2);
            border-radius: 50%;
            width: ${pointConfig.internalCircleWidth};
            height: ${pointConfig.internalCircleWidth};
            background: ${disabled ? theme.colorControlBorderDisabled : theme.colorBorderMain};
        }
    `}

    ${({ theme, disabled, interactiveMode }) => !disabled &&
    interactiveMode &&
    (0, styled_components_1.css) `
            &:hover {
                background-color: ${theme.colorHighlightLight};
            }

            &:active {
                background-color: ${theme.colorHighlightDark};
            }

            &:hover,
            &:active {
                &:after {
                    background: ${theme.colorControlIcon};
                }
            }
        `}
`;
exports.StyledSliderStepLabel = (0, styled_components_1.default)(Text_1.Text) `
    position: absolute;
    top: calc(
        ${exports.trackConfig.height} + ${exports.labelConfig.marginTop} +
            (${exports.trackConfig.areaClickHeight} - ${exports.trackConfig.height}) / 2
    );
    line-height: ${exports.labelConfig.height};

    ${({ value, isSecond }) => {
    if (isSecond) {
        return (0, styled_components_1.css) `
                right: calc(${100 - value}% + ${exports.thumbConfig.padding} - ${exports.thumbConfig.width} / 2);
            `;
    }
    return (0, styled_components_1.css) `
            left: calc(${value}% + ${exports.thumbConfig.padding} - ${exports.thumbConfig.width} / 2);
        `;
}}
`;
//# sourceMappingURL=Slider.styles.js.map